/* 全局消息事件(嵌套iframe消息事件)监听 */
import {
  registReturnGameFunction,
  registFunSuccessReportFunction,
  registRefreshFunction,
  registLoginVerifySuccessFunction,
  goToGameServerWithRoleId,
  createGameRoleWithRoleId,
  registLogoutFunction,
  updateLevelEventWithLevel,
  getDeviceMemoryInfo,
  handleNativeStorage,
  gameOpenDownloads
} from '@/bridge/AppJsBridge';
import { isPure, isAndroid } from '@/libs/utils';
import _ from 'lodash';
import { handleThirdLib } from '@/libs/business/account';
import { getStorage } from '@/libs/utils';
import { globalErrReport } from '@/api/log';
import log from './log';


/* 
  action类型：
  getUser.游戏初始化调用
  setUser.游戏服务端二次验证成功后调用
  logout.登出
  showOrder.调起支付窗口
  cancelOrder.支付失败
  orderOk.支付成功
  shutDown.关闭登录窗口
  YWPlayerStatusCreate.创建角色
  YWPlayerStatusLevelUp.角色升级
  YWPlayerStatusEnterServer.进入服务器
  YwOpenOrder.打开了个新连接
  didReceiveMemoryWarning.ios获取内存信息
  */
const ACTION_LIST = [
  'getUser',
  'setUser',
  'logout',
  'showOrder',
  'cancelOrder',
  'orderOk',
  'shutDown',
  'YWPlayerStatusStartCreate',
  'YWPlayerStatusCreate',
  'YWPlayerStatusLevelUp',
  'YWPlayerStatusEnterServer',
  'YwOpenOrder',
  'getReceiveMemoryInfo',
  'setStorage',
  'getStorage',
  'gameOpenDownload',
  'getOrderState',
  'cxShowOrder'
];

export default {
  namespaced: true,
  state: {
    loginCallback: null,
    memoryCallback: null,
    notifyIdentifier: false,
    orderCallback: null
  },
  mutations: {
    CHANGE_STATE: (state, obj) => {
      state = Object.assign(state, obj);
    },
  },
  getters: {},
  actions: {
    monitorInit({ dispatch }) {
      window.addEventListener('message', function (e) {
        let obj = e.data;
        if (!obj || !obj.action || !obj.params) {
          // process.env.NODE_ENV != 'production' &&
          //   console.log('game msg params error:' + JSON.stringify(obj));
          return;
        }
        if (ACTION_LIST.includes(obj.action)) {
          dispatch(obj.action, obj);
        } else {
          console.warn(`unknown action ${obj.action}`);
        }
      });
    },
    logout() {
      // 如果是h5，ios部分包未提供退出登录方法，需要刷新页面
      if (!isPure()) {
        location.reload();
      } else {
        registLogoutFunction(null);
      }
    },
    // 游戏初始化
    getUser({ state, rootState, commit }, obj) {
      const { callback } = obj.params;
      const { user } = rootState;
      if (user.h5Preload && !state.notifyIdentifier) {
        commit('CHANGE_STATE', { loginCallback: callback });
      } else {
        const params = {
          session_id: user.session_id,
          type: user.appkey,
          os: user.device_info.os,
          devicetype: user.device_info.devicetype,
          userId: user.user_id
        };
        window.frames['gameFrame'].postMessage({ action: callback, params }, '*');
      }
    },
    notifyLogin({ rootState, state, commit }) {
      const { loginCallback } = state;
      const { user } = rootState;
      const params = {
        session_id: user.session_id,
        type: user.appkey,
        os: user.device_info.os,
        devicetype: user.device_info.devicetype,
        userId: user.user_id
      };
      if (!loginCallback) {
        console.log('error: loginCallback undefined')
        commit('CHANGE_STATE', { notifyIdentifier: true })
        return;
      }
      window.frames['gameFrame'].postMessage({ action: loginCallback, params }, '*');
    },
    // 二次验证后
    async setUser({ rootState, commit, dispatch }, obj) {
      let userInfo = obj.params;
      const { user, global } = rootState;
      commit(
        'user/CHANGE_STATE',
        {
          user_id: userInfo.uid || user.user_id,
          username: userInfo.name || user.username,
          session_id: userInfo.session_id || user.session_id,
          thirdLoginVisible: false,
          loginVisible: false,
          cellLoginVisible: false,
          quickRegisterVisible: false,
          cellRegisterVisible: false,
          suspendVisible: true
        },
        { root: true }
      );
      const isSilentLogin = getStorage('isSilentLogin');
      if (isSilentLogin) {
        commit('user/CHANGE_STATE', { silentHintShow: true, suspendVisible: false }, { root: true });
        setTimeout(() => {
          commit('user/CHANGE_STATE', { silentHintShow: false }, { root: true });
        }, 2000)
      }
      commit('global/clearLoading', null, { root: true });

      const cacheList = ['user_id', 'username', 'session_id'];
      dispatch('user/cacheState', cacheList, { root: true });

      // 不显示悬浮窗的情况
      const forceNormalLogin = getStorage('force_normal_login')
      const ysdkStatus = isAndroid() && user.ysdk_status == 0 && !forceNormalLogin
      if (ysdkStatus || user.app_status == '1' || global.hidefloat) {
        commit('user/CHANGE_STATE', { suspendVisible: false }, { root: true });
      }

      dispatch('user/antiIndulged', null, { root: true });
      dispatch('user/blockDiagnose', null, { root: true });
      // dispatch('voucher/getShowList', null, { root: true });
      dispatch('suspend/getRemind', null, { root: true });
      // 通知APP登录成功
      registLoginVerifySuccessFunction({
        user_id: user.user_id,
        user_name: user.username,
        user_passwords: user.password,
        register_time: user.register_time,
        access_token: user.access_token
      });
      setTimeout(() => {
        // // 显示强更礼包
        if (user.update_gift_status == 1) {
          commit('user/CHANGE_STATE', { updateGiftVisible: true }, { root: true });
        } else if (user.is_vip && user.vip_type == 2) {
          // 显示vip 两个弹框避开
          commit('user/CHANGE_STATE', { vipVisible: true }, { root: true });
        }
      }, 1000);

      // 逍遥合击查问题，临时增加日志上报
      const pid = getStorage('pid');
      if (pid == 102816) {
        globalErrReport({
          type: 'xyhj_h5_set_user',
          userId: userInfo.uid,
          appkey: user.appkey
        })
      }
    },
    showOrder({ commit, rootState, dispatch }, obj) {
      console.log('order info', JSON.parse(obj.params))
      let orderInfo = JSON.parse(obj.params);
      dispatch('pay/getPayTypeList', orderInfo, { root: true });
      commit('pay/CHANGE_STATE', { order_info: orderInfo, qrCodeVisible: false, qrCodeLink: '' }, { root: true });
      // 重置支付窗口状态和防重复点击状态
      commit('global/CHANGE_STATE', { preventBrush: false }, { root: true });
    },
    cxShowOrder({ commit, rootState, dispatch }, obj) {
      //console.log('order info', JSON.parse(obj.params))
      const { callback, param } = obj.params;
      console.log(callback);
      let orderInfo = JSON.parse(param);
      if (callback) {
        commit('CHANGE_STATE', { orderCallback: callback });
      }
      dispatch('pay/getPayTypeList', orderInfo, { root: true });
      commit('pay/CHANGE_STATE', { order_info: orderInfo, qrCodeVisible: false, qrCodeLink: '' }, { root: true });
      // 重置支付窗口状态和防重复点击状态
      commit('global/CHANGE_STATE', { preventBrush: false }, { root: true });
    },

    cancelOrder({ commit, dispatch }) {
      dispatch('pay/queryOrderResult', { root: true });
      // commit('global/showCommonToast', '支付失败，支付结果请以实际游戏币为准', { root: true });
      // commit('user/CHANGE_STATE', { chargeVisible: false }, { root: true })
      // commit('pay/CHANGE_STATE', { orderShow: false, orderIframeLink: '' }, { root: true })
    },
    // 支付成功
    orderOk({ commit, rootState, dispatch }) {
      dispatch('pay/queryOrderResult', { root: true });
      // commit('global/showCommonToast', '支付成功，支付结果请以实际游戏币为准', { root: true });
      // commit('user/CHANGE_STATE', { chargeVisible: false }, { root: true });
      // const {
      //   pay: { order_info, thirdLibs, img_class_name, pay_type, order_sn },
      //   user: { user_id }
      // } = rootState;
      // let orderInfo = _.cloneDeep(order_info);
      // if (isAndroid()) {
      //   orderInfo.zfAmount =
      //     handleThirdLib(orderInfo.zfAmount / 100, thirdLibs) || orderInfo.zfAmount / 100;
      // } else {
      //   orderInfo.zfAmount =
      //     handleThirdLib(orderInfo.zfAmount, thirdLibs) || orderInfo.zfAmount;
      // }
      // orderInfo.type = img_class_name
      // orderInfo.pay_type = pay_type;
      // orderInfo.uid = user_id;
      // orderInfo.yw_order_sn = order_sn;
      // registFunSuccessReportFunction(orderInfo);
      // commit('pay/CHANGE_STATE', {
      //   orderShow: false,
      //   orderIframeLink: '',
      //   order_sn: ''
      // }, { root: true });
      // setTimeout(function() {
      //   registReturnGameFunction(null);
      // }, 2000);
    },
    // 关闭登录框（跳过二次验证赋值）
    shutDown({ dispatch }) {
      dispatch('setUser', { params: {} });
    },
    // 进入创角界面
    YWPlayerStatusStartCreate({ dispatch }, obj) {
      dispatch('log/roleCreateReport', obj.params, { root: true });
    },
    // 角色创建
    YWPlayerStatusCreate({ dispatch }, obj) {
      dispatch('log/roleUpdateReport', obj.params, { root: true });
      dispatch('log/roleCreateSuccessReport', obj.params, { root: true });
      createGameRoleWithRoleId(obj.params);
    },
    // 角色升级
    YWPlayerStatusLevelUp({ dispatch }, obj) {
      dispatch('log/roleUpdateReport', obj.params, { root: true });
      updateLevelEventWithLevel(obj.params);
    },
    // 进入服务器
    YWPlayerStatusEnterServer({ dispatch, commit }, obj) {
      const { roleId, roleLevel, roleName, serverName, serverId, serverCreatedAt } = obj.params
      // 进入服务器日志上报
      dispatch('log/enterServerReport', obj.params, { root: true });
      dispatch('log/enterServerGSReport', obj.params, { root: true });
      dispatch('activity/handleActivityShow', obj.params, { root: true });
      commit('suspend/CHANGE_STATE', {
        role: {
          role_id: roleId,
          level: roleLevel,
          role_name: roleName,
          server_name: serverName,
          server_id: serverId,
          server_created_at: serverCreatedAt
        }
      }, { root: true })
      commit('redEnvelope/CHANGE_STATE', {
        role: {
          role_id: roleId,
          level: roleLevel,
          role_name: roleName,
          server_name: serverName,
          server_num: serverId,
          server_created_at: serverCreatedAt
        }
      }, { root: true })
      if (obj.params) {
        commit('user/CHANGE_STATE', {
          server: obj.params.serverName,
          role_name: obj.params.roleName
        }, { root: true })
        dispatch('user/cacheState', ['server', 'role_name'], { root: true })
      }
      goToGameServerWithRoleId(obj.params);
    },
    YwOpenOrder({ }, obj) {
      location.href = obj.params;
    },
    // ios获取内存信息
    getReceiveMemoryInfo({ commit }, obj) {
      const { callback } = obj.params;
      commit('CHANGE_STATE', { memoryCallback: callback })
      getDeviceMemoryInfo((params) => {
        window.frames['gameFrame'].postMessage({ action: callback, params }, '*');
      })
    },
    setStorage({ commit }, obj) {
      console.log(281, obj)
      handleNativeStorage({
        gs: 0,
        key: obj.params.key,
        value: obj.params.value,
      }, function (data) {
      })
    },
    getStorage({ commit }, obj) {
      handleNativeStorage({
        gs: 1,
        key: obj.params.key,
        value: "",
      }, function (data) {
        window.frames['gameFrame'].postMessage({ action: 'getStorageCallback', params: data }, '*');
      })
    },
    gameOpenDownload({ commit }, obj) {
      gameOpenDownloads({
        gameUrl: obj.params
      })
    },
  }
};
